module.exports = __webpack_public_path__ + "static/img/bg-ar.73854d69.png";